import { tx } from '@transifex/native';

tx.init({
  // Public project token, defaults to empty string
  token: import.meta.env.VITE_REACT_APP_TRANSIFEX_TOKEN,
  sourceLocale: ['en', 'fr']
});

// eslint-disable-next-line no-barrel-files/no-barrel-files
export default tx;
